import * as yup from 'yup';

export const settingsFormSchema = yup.object({
  receivePushNotifications: yup.boolean().required(),
  receiveSmsNotifications: yup.boolean().required(),
  receiveScheduleNotifications: yup.boolean().required(),
});
